<ng-container class="modal-body" *ngIf="dataLoaded">
    <h2>{{message}}</h2>
    <div class="modal-footer">
        <div class="btn--group">
            <button class="btn--primary" type="submit" (click)="onSaveClick()">Ok</button>
        </div>
    </div>
</ng-container>